const Art = () => {
  return (
    <div
      id="art"
      className=" relative w-full h-full bg-grayy px-[calc((100%-var(--container))/2)] py-14 xl:py-28"
    >
      {/* <div id="title" className="text-point">
        <h3>COFFEE IS ART</h3>
      </div> */}
      <div className=" relative w-full h-full /mt-14 grid xl:grid-cols-2 gap-5 xl:gap-10">
        <div
          // data-aos="fade-right"
          className=" relative w-full h-full"
        >
          <img
            className="!relative w-full h-full object-cover object-center"
            src="images/art1.png"
            alt="art"
            width={688}
            height={476}
          />
        </div>
        <div className=" relative w-full h-full leading-relaxed grid items-center">
          <div>
            <div className="leading-snug">
              <p className="continuous italic font-black">MASTER sarah CHOI</p>
              <h4 className="text-point mb-5 xl:mb-6">
                MASTER의 손에서 나오는 최상의 맛을 내는 하나의 작품
              </h4>
            </div>
            <small>
              Sarah choi 마스터는 미국에서 순수미술을 전공을 통한 뛰어난
              컬러감각으로 커피 특유의 컬러를 연구하였으며, 이탈리아의 커피
              로스팅 명장으로부터 로스팅 기술을 배우고, 35년 동 안의 기간동안
              쌓은 프로파일링으로 통해서 최고의 로스팅과 블랜딩 기술을 보유 하고
              있습 니다. 많은 시간을 커피 연구에 투자하여 새로운 허브 커피 개발
              및 홀랜드 라는 제품 개발등 을 하였습니다.
            </small>
            <div
              // data-aos="fade-left"
              className="relative w-full h-fit grid grid-cols-2 gap-2 lg:gap-5 mt-6"
            >
              <div className=" relative w-full h-64 2xl:h-80 rounded-3xl overflow-hidden">
                <img
                  className="!relative w-full h-full object-cover object-center hover:scale-110 transition-all duration-200"
                  src="images/art2.png"
                  alt="art"
                />
              </div>
              <div className=" relative w-full h-64 2xl:h-80 rounded-3xl overflow-hidden">
                <img
                  className="!relative w-full h-full object-cover object-center hover:scale-110 transition-all duration-200"
                  src="images/art3.png"
                  alt="art"
                />
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Art;
